<template>
  <div>
    <v-alert dense outlined type="info" color="blue" class="mb-0 mt-8 px-1 py-1">
      Os dados retornados pelo sistema são limitados a 100 linhas.
    </v-alert>

    <v-alert v-if="errorSql" dense outlined type="error" color="red" class="mb-0 mt-4 mx-4 px-1 py-1">
      {{ errorSql }}
    </v-alert>

    <v-data-table
      :headers="headers"
      :items="queryData"
      :mobile-breakpoint="800"
      :loading="loadingExecQuery"
      :hide-default-header="loadingExecQuery"
      :hide-default-footer="loadingExecQuery"
      class="mt-8"
      no-data-text="Nenhum dado disponível"
    >
      <template v-slot:[`footer.page-text`]>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" v-bind="attrs" v-on="on" @click="$emit('refresh')">mdi-refresh</v-icon>
          </template>
          <span>Clique aqui para recarregar os dados</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    props: {
      headers: {
        type: Array,
        default: () => []
      },
      queryData: {
        type: Array,
        default: () => []
      },
      errorSql: {
        type: String,
        default: () => ''
      },
      loadingExecQuery: {
        type: Boolean,
        default: () => false
      }
    }
  };
</script>
